module.exports = __webpack_public_path__ + "media/customizations/bramlife/logo-82b1a2390cb30be15dc4db4c0d8cee5b.png";